exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@import url('https://fonts.googleapis.com/css?family=Roboto:300,300i,400,400i,900,900i');\n@import url('https://file.myfontastic.com/ZsQe5ZjXFD8oURQmj6eGxL/icons.css');\n@import url('https://cdnjs.cloudflare.com/ajax/libs/animate.css/3.5.2/animate.min.css');\n.container {\n  font-family: 'Roboto', sans-serif;\n  text-transform: uppercase;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/Putman/Desktop/Javascript Projects/angular-portfolio/src/app/app.component.css
// module id = ../../../../../src/app/app.component.css
// module chunks = main